<script lang="ts">
	import * as Avatar from '$lib/shadcn/components/ui/avatar';
	import { User } from '@lucide/svelte';
	import _ from 'lodash';
	import type { ClassValue } from 'svelte/elements';

	let { name, class: classList }: { name: string; class?: ClassValue } = $props();
	let initials = $derived(
		name
			.split(' ', 2)
			.map((str) => str.at(0))
			.filter(_.isString)
			.join('')
	);
</script>

<Avatar.Root class={classList}>
	<Avatar.Fallback class="preset-tonal">
		{#if initials.length > 0}
			{initials}
		{:else}
			<User />
		{/if}
	</Avatar.Fallback>
</Avatar.Root>
